module.exports = __webpack_public_path__ + "img/bg2-result.bf319c12.png";